import { useState, useEffect, useContext } from 'react'
import DashboardLayout from 'components/layout/dashboard/DashboardLayout'
import { useTranslation } from 'react-i18next';
import './externalDeposit.css'
import AuthContext from 'contexte/AuthContext';
import Modal from 'components/modal/Modal';
import { RELEASE_DATE, formatDate } from 'utils/date';
import { fetchExternalDeposit, linkToClient, fetchExternalDepositUser, createExternalDeposit } from 'services/depositServices';
import Tableau from 'components/DataComponents/Tableau/Tableau';
import FilterComponent from 'components/Filters/FilterComponent/FilterComponent';
import PageLoader from 'components/pageLoader/PageLoader';
import Notification from 'components/notifications/Notification';
import { launchSuccess, launchError } from 'components/notifications'
import { formatIBAN } from 'utils/iban';

const ExternalDeposit = () => {

  const { t } = useTranslation()
  const { user, verifyUser } = useContext(AuthContext)
  const role = verifyUser()?.role


  const [status, setStatus] = useState('ON%20HOLD')
  const [page, setPage] = useState(0)
  const [loading, setLoading] = useState(true)
  const [fetchLimit, setFetchLimit] = useState(10)
  const [externalDeposit, setExternalDeposit] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalIndex, setModalIndex] = useState(0)
  const [selectedDate, setSelectedDate] = useState({
    date1: { startDate: new Date(RELEASE_DATE), endDate: new Date() },
    date2: { startDate: null, endDate: null },
  });
  const [selectedUserLinked, setSelectedUserLinked] = useState({})
  const [selectedUser, setSelectedUser] = useState({});
  const [users, setUsers] = useState([])

  const [isCreationModalOpen, setIsCreationModalOpen] = useState(false)
  const [creationUserLinked, setCreationUserLinked] = useState({})
  const [creationSelectedUser, setCreationSelectedUser] = useState({});


  const fetchData = async () => {

    try {

      const externalDepositData = await fetchExternalDeposit(user, page, fetchLimit, status, selectedDate.date1.startDate, selectedDate.date1.endDate)

      setExternalDeposit(externalDepositData)
      setLoading(false)

    } catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    if (selectedDate.date1.startDate !== null && selectedDate.date1.endDate !== null) {
      fetchData()
    }
  }, [fetchLimit, status, page, selectedDate])

  const resetFilter = () => {
    setFetchLimit(10)
    setSelectedDate({
      date1: { startDate: new Date(RELEASE_DATE), endDate: new Date() },
      date2: { startDate: null, endDate: null },
    })
  }

  const onClickFunction = (index) => {
    setModalIndex(index)
    setIsModalOpen(true);
  }

  const transformDataToTbody = (data) => {
    if (data.length > 0) {
      return data?.map((item) => {
        return {
          data: [
            item.account_holder_name,
            formatIBAN(item.account_identifier?.iban),
            item.transaction[0].amount + ' ' + item.transaction[0].currency,
            formatDate({ date: item.createdAt, time: true })
          ]
        }
      })
    } else {
      return []
    }
  }

  const closeAndInitModalAndLister = (modalIndex) => {
    setExternalDeposit((prevState) => {
      const newState = [...prevState]
      newState.splice(modalIndex, 1)
      return newState
    });
    setSelectedUser({});
    setSelectedUserLinked({});
    setModalIndex(-1);
    setIsModalOpen(false);
    setUsers([])
  }

  const linkMatchingUser = async () => {
    try {
      const userToLink = selectedUser?.uuid ? selectedUser : selectedUserLinked;
      if (!userToLink?.uuid) {
        return launchError(t('notifications.payouts.externalDeposits.link.no_user_selected'))
      }
      await linkToClient(user, externalDeposit[modalIndex]._id, userToLink.uuid)
      closeAndInitModalAndLister(modalIndex);
      launchSuccess(t('notifications.payouts.externalDeposits.link.success'))
    } catch (e) {
      launchError(t('notifications.payouts.externalDeposits.link.error'))
    }
  }

  const closeCreationModal = () => {
    setCreationSelectedUser({});
    setCreationUserLinked({});
    setIsCreationModalOpen(false);
    setUsers([])
  }

  const createDeposit = async (createDepositUser, amount, iban, bic) => {
    try {
      if (!createDepositUser?.uuid) {
        return launchError(t('notifications.payouts.externalDeposits.create.no_user_selected'))
      }
      console.log(createDepositUser, amount)
      await createExternalDeposit(user, createDepositUser.uuid, amount, iban, bic)
      closeCreationModal();
      fetchData()
      launchSuccess(t('notifications.payouts.externalDeposits.create.success'))
    } catch (e) {
      launchError(t('notifications.payouts.externalDeposits.create.error'))
    }
  }

  const handleSearch = async (search) => {
    if (search.length > 0) {
      try {
        const fetchUsers = await fetchExternalDepositUser(user, search)
        setUsers(fetchUsers)
        setLoading(false)
      } catch (e) {
        console.error(e)
      }
    } else {
      setUsers([])
    }
  }

  return (
    <DashboardLayout page={t("pages_name.externalDeposit")}>
      <div>
        {!loading ? (
          <div>
            <Notification />
            <div className='externalDeposit_titleComponent'>
              <h2>{t("pages.externalDeposit.title")}</h2>
              <div className='externalDeposit_statusFilters'>
                <div onClick={() => { setStatus('ON%20HOLD') }} className={`${status === "ON%20HOLD" && "externalDeposit_statusSelected"} externalDeposit_statusBox`}>{t("pages.externalDeposit.waiting")}</div>
                <div onClick={() => { setStatus('SUCCESS') }} className={`${status === "SUCCESS" && "externalDeposit_statusSelected"} externalDeposit_statusBox`}>{t("pages.externalDeposit.sucess")}</div>
              </div>
              <FilterComponent
                resetFilter={resetFilter}
                limit={true}
                date={true}
                fetchLimit={fetchLimit}
                setFetchLimit={setFetchLimit}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
              />
            </div>

            {role === 1 && <div className='external_deposit_creation_box'>
              <button className='external_deposit_creation_button' onClick={() => setIsCreationModalOpen(true)}>Créer dépôt externe</button>
            </div>}

            <div className="table-container">
              <div className="table-column">
                <Tableau
                  thead={[t("pages.externalDeposit.name"), t("pages.externalDeposit.iban"), t("pages.externalDeposit.amount"), t("pages.externalDeposit.date")]}
                  tbody={transformDataToTbody(externalDeposit)}
                  hadModal={true}
                  onClickFunction={onClickFunction}
                  page={page}
                  setPage={setPage}
                  pagination={true}
                  limit={fetchLimit}
                />
              </div>
            </div>

            {
              isModalOpen && status === "ON%20HOLD" && (
                <ModalPending isModalOpen={isModalOpen}
                  linkMatchingUser={linkMatchingUser}
                  setSelectedUserLinked={setSelectedUserLinked}
                  selectedUserLinked={selectedUserLinked}
                  onClose={() => setIsModalOpen(false)}
                  closeButton
                  externalDeposit={externalDeposit}
                  modalIndex={modalIndex}
                  handleSearch={handleSearch}
                  users={users}
                  selectedUser={selectedUser}
                  setSelectedUser={setSelectedUser} />
              ) || isModalOpen && status === "SUCCESS" && (
                <ModalSuccess isModalOpen={isModalOpen} onClose={() => setIsModalOpen(false)} closeButton externalDeposit={externalDeposit} modalIndex={modalIndex} />
              )
            }

            <ModalCreateDeposit
              isCreationModalOpen={isCreationModalOpen}
              onClose={() => setIsCreationModalOpen(false)}
              handleSearch={handleSearch}
              createDeposit={createDeposit}
              setSelectedUserLinked={setCreationUserLinked}
              selectedUserLinked={creationUserLinked}
              closeButton
              users={users}
              selectedUser={creationSelectedUser}
              setSelectedUser={setCreationSelectedUser}
            />
          </div>
        ) : (
          <div className='pageLoaderBox'>
            <PageLoader />
          </div>
        )}
      </div>
    </DashboardLayout>
  )
}


export default ExternalDeposit

// MODALES

const ModalPending = ({ isModalOpen, linkMatchingUser, setSelectedUserLinked, selectedUserLinked, onClose, externalDeposit, modalIndex, handleSearch, users, setSelectedUser, selectedUser }) => {

  const { t } = useTranslation()

  const handleSelectUserLinked = (user) => {
    setSelectedUserLinked(prevState => prevState.uuid === user.uuid ? {} : user);
    handleSearch('')
    setSelectedUser({})
  }

  return (
    <Modal isOpen={isModalOpen} onClose={onClose} closeButton >
      <h2 className='modal_title'>{t("pages.externalDeposit.pendingModal.title")}</h2>
      <div className="payout-details">
        <p><strong>{t("pages.externalDeposit.pendingModal.name")}:</strong> {externalDeposit[modalIndex].account_holder_name}</p>
        <p><strong>{t("pages.externalDeposit.pendingModal.reference")}:</strong> {externalDeposit[modalIndex].reference}</p>
        <p><strong>{t("pages.externalDeposit.pendingModal.date")}:</strong> {formatDate({ date: externalDeposit[modalIndex].createdAt, time: true })}</p>
        <p><strong>{t("pages.externalDeposit.pendingModal.iban")}:</strong> {formatIBAN(externalDeposit[modalIndex]?.account_identifier?.iban)}</p>
        <p><strong>{t("pages.externalDeposit.pendingModal.amount")}:</strong> {externalDeposit[modalIndex].transaction[0].amount + ' ' + externalDeposit[modalIndex].transaction[0].currency}</p>
        <p><strong>{t("pages.externalDeposit.pendingModal.updated_at")}:</strong> {formatDate({ date: externalDeposit[modalIndex].updatedAt, time: true })}</p>
      </div>
      <hr className='modal_hr_button' />
      <div className='external_deposits_matching_users_box'>
        {externalDeposit[modalIndex].matching_users.length > 0 && (
          <ul>
            {externalDeposit[modalIndex].matching_users.map((item, index) => {
              return (
                <li key={index} onClick={() => handleSelectUserLinked(item)}
                  className={`${selectedUserLinked.uuid === item.uuid ? "linkedUserSelect" : "linkedUserNotSelect"}`}>
                  <div className='item_selectMatchingUser'>
                    <p>{item.firstName + " " + item.lastName}</p>
                    <p>{item.email}</p>
                    <p></p>
                  </div>
                </li>
              )
            })}
          </ul>
        )}
      </div>
      <UserSearchModal setSelectedUser={setSelectedUser} selectedUser={selectedUser} users={users} handleSearch={handleSearch} setSelectedUserLinked={setSelectedUserLinked} selectedUserLinked={selectedUserLinked} />
      <div className='modal-button-div'>
        <button className='close' onClick={onClose}>{t("pages.externalDeposit.pendingModal.close")}</button>
        <button
          className='valider'
          onClick={linkMatchingUser}
          disabled={!selectedUser?.uuid && !selectedUserLinked.uuid}
        >{t("pages.externalDeposit.pendingModal.linked")}</button>

      </div>
    </Modal>
  )
}

const ModalSuccess = ({ isModalOpen, onClose, externalDeposit, modalIndex }) => {

  const { t } = useTranslation()

  return (
    <Modal isOpen={isModalOpen} onClose={onClose} closeButton >
      <h2 className='modal_title'>Détail du payout</h2>
      <div className="payout-details">
        <p><strong>{t("pages.externalDeposit.pendingModal.name")}:</strong> {externalDeposit[modalIndex].account_holder_name}</p>
        <p><strong>{t("pages.externalDeposit.pendingModal.reference")}:</strong> {externalDeposit[modalIndex].reference}</p>
        <p><strong>{t("pages.externalDeposit.pendingModal.date")}:</strong> {formatDate({ date: externalDeposit[modalIndex].createdAt, time: true })}</p>
        <p><strong>{t("pages.externalDeposit.pendingModal.iban")}:</strong> {externalDeposit[modalIndex].account_identifier.iban}</p>
        <p><strong>{t("pages.externalDeposit.pendingModal.amount")}:</strong> {externalDeposit[modalIndex].transaction[0].amount + ' ' + externalDeposit[modalIndex].transaction[0].currency}</p>
        <p><strong>{t("pages.externalDeposit.pendingModal.updated_at")}:</strong> {formatDate({ date: externalDeposit[modalIndex].updatedAt, time: true })}</p>
        <p><strong>{t("pages.externalDeposit.pendingModal.benefinary")}:</strong> {externalDeposit[modalIndex].linked_user.firstName + " " + externalDeposit[modalIndex].linked_user.lastName}</p>
      </div>
      <hr className='modal_hr_button' />
      <div className='modal_input_container'>
        <div className='modal-button-div'>
          <button className='close' onClick={onClose}>{t("pages.externalDeposit.pendingModal.close")}</button>
        </div>
      </div>
    </Modal>
  )
}

const UserSearchModal = ({ setSelectedUser, selectedUser, users, handleSearch, setSelectedUserLinked }) => {


  const updateSearch = (searchText) => {
    handleSearch(searchText);
  };

  const selectUser = (user) => {
    setSelectedUserLinked({});
    setSelectedUser(user);
  };


  const clearSelection = () => {
    setSelectedUserLinked({});
    setSelectedUser({});
    updateSearch('')
  };

  return (
    <div className='modal_input_container'>
      {Object.keys(selectedUser).length === 0 ? (
        <input
          type="text"
          placeholder='Entrer un email'
          className='input_sleectedUser'
          onChange={(e) => updateSearch(e.target.value)}
        >

        </input>
      ) : (
        <div className={`${selectedUser?.uuid ? "linkedUserSelect" : "linkedUserNotSelect"} relative`}>
          <span onClick={() => selectUser(selectedUser)}>
            <p>{selectedUser.firstName} {selectedUser.lastName}</p>
            <p>({selectedUser.email})</p>
          </span>
          <div onClick={() => clearSelection()} className='delete_item_select'>x</div>
        </div>
      )}
      {Object.keys(selectedUser).length === 0 && users.length > 0 && (
        <ul className='users_list_box'>
          {users.map((user, index) => (
            <li key={index} onClick={() => selectUser(user)} className="linkedUserNotSelect">
              <div className='item_selectMatchingUser'>
                <p>{user.firstName + " " + user.lastName}</p>
                <p>{user.email}</p>
                <p></p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const ModalCreateDeposit = ({ isCreationModalOpen, onClose, createDeposit, setSelectedUserLinked, selectedUserLinked, handleSearch, users, setSelectedUser, selectedUser }) => {

  const { t } = useTranslation()

  const [amount, setAmount] = useState(0);
  const [userModal, setUserModal] = useState({});
  const [iban, setIban] = useState('');
  const [bic, setBic] = useState('');

  const handleAmount = (event) => {
    const value = event.target.value;
    if (!value || value.match(/^\d{1,}(\.\d{0,4})?$/)) {
      setAmount(+value);
    } else {
      launchError(t('notifications.payouts.manual_payout.verify.not_a_number'))
    }
  };

  const create = () => {
    createDeposit(userModal, amount, iban, bic)
    setUserModal({})
    setAmount(0)
    setIban('')
    setBic('')
  }

  return (
    <Modal isOpen={isCreationModalOpen} onClose={onClose} closeButton >
      <h2 className='modal_title'>{t("pages.externalDeposit.creationModal.title")}</h2>
      <div className="payout-details">
        <p><strong>{t("pages.externalDeposit.creationModal.amount")}:</strong>
          <input type='number' value={amount} className='external_deposit_creation_amount_input' onChange={(e) => handleAmount(e)} />
        </p>
        <p><strong>{t("pages.externalDeposit.creationModal.iban")}:</strong>
          <input type='text' value={iban} className='external_deposit_creation_iban_input' onChange={(e) => setIban(e.target.value)} />
        </p>
        <p><strong>{t("pages.externalDeposit.creationModal.bic")}:</strong>
          <input type='text' value={bic} className='external_deposit_creation_bic_input' onChange={(e) => setBic(e.target.value)} />
        </p>
      </div>
      <hr className='modal_hr_button' />
      <UserSearchModal setSelectedUser={setUserModal} selectedUser={userModal} users={users} handleSearch={handleSearch} setSelectedUserLinked={() => { }} />
      <div className='modal-button-div'>
        <button className='close' onClick={onClose}>{t("pages.externalDeposit.creationModal.close")}</button>
        <button
          className='valider'
          onClick={create}
          disabled={!userModal?.uuid || isNaN(amount) || amount <= 0}
        >{t("pages.externalDeposit.creationModal.create")}</button>

      </div>
    </Modal>
  )
}